type Timeout = ReturnType<typeof setTimeout>

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function leadingDebounce<T extends (...args: any[]) => void>(
  func: T,
  delay: number
): (...funcArgs: Parameters<T>) => void {
  let timerId: Timeout | undefined
  let shouldSkipTrailing = false

  return (...args: Parameters<T>): void => {
    if (!timerId) {
      func(...args) // Leading call (only on first invocation)
      shouldSkipTrailing = true
    } else {
      shouldSkipTrailing = false // Mark to skip trailing if no further calls
    }

    clearTimeout(timerId)
    timerId = setTimeout(() => {
      if (!shouldSkipTrailing) {
        func(...args) // Trailing call (only if interrupted)
      }
      clearTimeout(timerId)
    }, delay)
  }
}